import { render } from "./LuckyStatisticsOE.vue?vue&type=template&id=20f573e7"
import script from "./LuckyStatisticsOE.vue?vue&type=script&lang=js"
export * from "./LuckyStatisticsOE.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__